import { render, staticRenderFns } from "./ShowcasePricesModal.vue?vue&type=template&id=b78d879e&"
import script from "./ShowcasePricesModal.vue?vue&type=script&lang=js&"
export * from "./ShowcasePricesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports